// Initialisation de Bootstrap 4 après que jQuery soit chargé
jQuery(function () {
    // Exposer jQuery globalement pour que Bootstrap 4 s'y enregistre
    window.jQuery = window.$ = jQuery;
    globalThis.jQuery = globalThis.$ = jQuery;
    const userWeight = document.querySelector('meta[name="user-weight"]')?.getAttribute('content') || '0';
    const showLogs = Number.parseInt(userWeight) >= 80;

    // Importer Bootstrap 4 bundle (inclut Popper et les plugins jQuery)
    import('~bootstrap/dist/js/bootstrap.bundle.min.js?url').then((url) => {
        const script = document.createElement('script');
        script.src = url.default;
        script.onload = () => {
            if (showLogs) {
                console.log('Bootstrap 4 initialization started');
            }
            // Réinitialiser les dropdowns Bootstrap
            $('.dropdown-toggle').dropdown();

            // Réinitialiser les tooltips si nécessaire
            $('[data-toggle="tooltip"]').tooltip();

            // Réinitialiser les popovers si nécessaire
            $('[data-toggle="popover"]').popover();

            if (showLogs) {
                console.log('Bootstrap 4 initialization completed');
            }
        };
        document.head.appendChild(script);
    }).catch(error => {
        if (showLogs) {
            console.log("jQuery loaded?", typeof $ !== 'undefined');
            console.log("Boostrap 4 loaded?", typeof $.fn.dropdown !== 'undefined');
            console.error('Bootstrap 4 failed to load', error);
        }
    });
});
